import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { BRAND, OFFER_ANCHOR, PACK_IMAGE, PRODUCT } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-night" data-id="element-108" data-mp="4m8msdv40tlg">
      <div className="bg-carbon" data-id="element-109" data-mp="4n1ov1j4iux9">
        <p className="mx-auto max-w-page px-3 py-1.5 text-center text-[0.6rem] font-extrabold uppercase tracking-[0.28em] text-volt sm:text-xs" data-id="element-110" data-mp="4jvxffn0vgyd">
          {BRAND}
        </p>
      </div>

      <div className="mx-auto flex max-w-page flex-col items-center px-3 pb-6 pt-4 text-center sm:px-6 sm:pb-8" data-id="element-111" data-mp="x8b85pz4fd3w">
        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="max-w-4xl font-display text-[1.45rem] uppercase leading-[1.05] text-volt sm:text-4xl lg:text-[3.1rem]" data-id="element-112" data-mp="sd4c94c3fcpj">
          ⚡ APRENDÉ ELECTRICIDAD DOMICILIARIA DESDE CERO
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.05
      }} className="mt-2 max-w-2xl text-sm font-bold leading-snug text-white sm:text-base" data-id="element-113" data-mp="3j9247l4e1kty">
          Con un sistema claro, visual y práctico, sin perderte entre
          información suelta.
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.09
      }} className="mt-3 block w-full max-w-2xl" data-id="element-114" data-mp="30h9djxcskbpe">
          <img src={PACK_IMAGE} alt={`${PRODUCT}: 6 tomos digitales y 5 bonos incluidos`} className="mx-auto w-full rounded-xl" data-id="element-115" data-mp="2vievwyqk8t6v" />
        </motion.a>

        <p className="mx-auto mt-3 max-w-3xl text-[0.8rem] leading-snug text-steel sm:text-sm md:text-base" data-id="element-116" data-mp="2lla70r5byjmd">
          Con <span className="font-bold text-white" data-id="element-117" data-mp="s2b73w324f43">{PRODUCT}</span> aprenderás
          a comprender una instalación básica, reconocer sus principales
          componentes, interpretar circuitos, utilizar el multímetro con fines
          educativos y desarrollar un método lógico para analizar fallas.{' '}
          <span className="font-bold text-volt" data-id="element-118" data-mp="de6munocvvj7">
            Incluso si hoy estás comenzando desde cero.
          </span>
        </p>

        <div className="mt-4 flex w-full flex-col items-center gap-2" data-id="element-119" data-mp="1ayt9d7fj7xel">
          <CtaButton size="lg" data-id="element-120" data-mp="16346ov87u0e2">
            <ZapIcon size={18} className="mr-2 flex-shrink-0" strokeWidth={2.5} data-id="element-121" data-mp="15zq0td0cf91v" />
            ¡SÍ! QUIERO APRENDER ELECTRICIDAD DESDE CERO
          </CtaButton>
          <p className="flex items-center gap-1.5 text-[0.7rem] font-bold uppercase tracking-wide text-steel sm:text-xs" data-id="element-122" data-mp="3lsysay1o8kij">
            <ShieldCheckIcon size={14} className="text-volt" data-id="element-123" data-mp="3hqu105yp3zz2" />
            Garantía de Devolución de 30 Días
          </p>
        </div>
      </div>
    </header>;
}